/* eslint-disable react/require-default-props */
/* eslint-disable import/order */
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";

import * as Yup from "yup";

import {
  Box,
  Container,
  List,
  ListSubheader,
  ListItem,
  ListItemButton,
  Stack,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { LockOutlined } from "@mui/icons-material";
import KeyIcon from "@mui/icons-material/Key";

import { ItemText } from "../../itemText";
import theme from "../../../theme";
import { Link } from "react-router-dom";

interface TicketingProps {
  aside?: any;
  asideSC?: boolean;
}
const Ticketing: React.FC<TicketingProps> = ({ aside, asideSC }) => {
  const [selectedItem, setSelectedItem] = React.useState("");

  React.useEffect(() => {
    if (window.location.pathname === "/recargas") {
      setSelectedItem("recarga");
    }
    if (window.location.pathname === "/verificacartao") {
      setSelectedItem("verificacartao");
    }
    if (window.location.pathname === "/cards") {
      setSelectedItem("cards");
    }
  }, [window.location.pathname]);
  return (
    <Box
      sx={{
        backgroundColor: "var(--aside-background)",
        display: "flex",
        borderRadius: 4,
      }}
    >
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: aside ? "250px" : "100%",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: 4,
            boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
            minWidth: aside ? "100%" : "250px",
          }}
        >
          <Stack>
            <ListSubheader
              sx={{
                backgroundColor: theme.palette.secondary.main,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                width: "100%",
                textAlign: "center",
              }}
            >
              <Box>
                <ItemText
                  primary="Ticketing"
                  hideSecondary
                  primarySx={{
                    color: "white",
                    fontSize: "20px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                />
              </Box>
            </ListSubheader>
          </Stack>
          <Stack>
            {!asideSC && (
              <Link to="/recargas">
                <ListItem
                  component={LoadingButton}
                  sx={{
                    backgroundColor:
                      selectedItem === "recarga" ? "#dd6d4b" : "white",
                    borderRadius: "10px",
                    textAlign: "center",
                  }}
                >
                  <ItemText
                    primary="RECARGAS"
                    hideSecondary
                    primarySx={{
                      color:
                        selectedItem === "recarga"
                          ? "white"
                          : theme.palette.primary.main,
                      fontWeight: "bold",
                      fontSize: "14px",
                      backgroundColor:
                        selectedItem === "recarga" ? "#dd6d4b" : "white",
                      borderRadius: "10px",
                    }}
                  />
                </ListItem>
              </Link>
            )}
            <Link to="/verificacartao">
              <ListItem
                component={LoadingButton}
                sx={{
                  backgroundColor:
                    selectedItem === "verificacartao" ? "#dd6d4b" : "white",
                  borderRadius: "10px",
                  textAlign: "center",
                }}
              >
                <ItemText
                  primary="Verificar Cartão"
                  hideSecondary
                  primarySx={{
                    color:
                      selectedItem === "verificacartao"
                        ? "white"
                        : theme.palette.primary.main,
                    fontWeight: "bold",
                    fontSize: "14px",
                    backgroundColor:
                      selectedItem === "verificacartao" ? "#dd6d4b" : "white",
                    borderRadius: "10px",
                  }}
                />
              </ListItem>
            </Link>
          </Stack>
          {/* <Stack>
            <Link to="/cards">
              <ListItem
                component={LoadingButton}
                sx={{
                  backgroundColor:
                    selectedItem === "cards" ? "#dd6d4b" : "white",
                  borderRadius: "10px",
                  textAlign: "center",
                }}
              >
                <ItemText
                  primary="CARTÕES TRANSFÁCIL"
                  hideSecondary
                  primarySx={{
                    color:
                      selectedItem === "cards"
                        ? "white"
                        : theme.palette.primary.main,
                    fontWeight: "bold",
                    fontSize: "14px",
                    backgroundColor:
                      selectedItem === "cards" ? "#dd6d4b" : "white",
                    borderRadius: "10px",
                  }}
                />
              </ListItem>
            </Link>
          </Stack> */}
        </Box>
      </List>
    </Box>
  );
};

export { Ticketing };
